/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-text[_ngcontent-%COMP%]{font-size:1.429rem;line-height:23px}.sub-text[_ngcontent-%COMP%]{color:#465a65;line-height:17px}.cancel-btn[_ngcontent-%COMP%]{line-height:18px}.enable-btn[_ngcontent-%COMP%]{font-size:1.143rem;line-height:19px}"];
export { styles as styles };
